import { render, staticRenderFns } from "./CommonClients.vue?vue&type=template&id=c8e9178e&scoped=true"
import script from "./CommonClients.vue?vue&type=script&lang=js"
export * from "./CommonClients.vue?vue&type=script&lang=js"
import style0 from "./CommonClients.vue?vue&type=style&index=0&id=c8e9178e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e9178e",
  null
  
)

export default component.exports